import React from "react";
import { Button } from "reactstrap";
import "../../assets/scss/components/Button/index.scss";
 

function CustomButton(props) {
  return (
    <React.Fragment>
      <div className="defaultbtn">
        {console.log("props",props.customDisable)}
        <Button
          type={props.customType}
          className={`${props.customClass}`}
          onClick={props.customClick}
          color={props.customColor}
          disabled={props.customDisable}
        >
          {props.name}
        </Button>
      </div>
    </React.Fragment>
  );
}

export default CustomButton;
